export function integrationsCatalogOverviewPage() {
  window.analytics.page('Integrations Catalog')
}

export function integrationsCatalogDetailPage() {
  window.analytics.page('Integrations Catalog Detail')
}

export function enforcementNotificationClicked(workspace, feature, targetPlan) {
  window.analytics.track(
    'Enforcement Notification Clicked',
    {
      workspace_id: workspace.id,
      workspace_slug: workspace.slug,
      feature,
      target_plan: targetPlan
    },
    {
      context: {
        groupId: workspace.id
      }
    }
  )
}

export function recommendationClicked(workspaceId, type, slug) {
  window.analytics.track(
    'Catalog Recommendation Clicked',
    {
      recommendation_slug: slug,
      type
    },
    {
      context: {
        groupId: workspaceId
      }
    }
  )
}

export function catalogCategoryClicked(workspaceId, type, category) {
  window.analytics.track(
    'Catalog Sidebar Category Clicked',
    {
      catalog_category: category,
      type
    },
    {
      context: {
        groupId: workspaceId
      }
    }
  )
}

export function recommendationCategoryClicked(workspaceId, type, category) {
  window.analytics.track(
    'Catalog Recommendation Category Clicked',
    {
      catalog_category: category,
      type
    },
    {
      context: {
        groupId: workspaceId
      }
    }
  )
}

export default {
  catalogCategoryClicked,
  recommendationClicked,
  integrationsCatalogOverviewPage,
  integrationsCatalogDetailPage,
  recommendationCategoryClicked
}
